import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useIsClient } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GridTileContainer } from '../../components/lister/GridTileContainer';
import { Events } from '../../enums/AnalyticsEnums';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import compareActions from '../../redux/compare/actions/CompareActions.creators';
import { makeGetCompareItems } from '../../redux/compare/selectors/CompareSelectors';
import { listerActions } from '../../redux/lister/actions/ListerActions.creators';
import { makeGetContentBlocks, makeGetLoadingState, makeGetProductSearchInformationState, makeGetSingleActiveSizeFilterKeyName, } from '../../redux/lister/selectors/ListerSelector';
import { makeGetUrlInformationPageSize, makeGetUrlInformationSearch } from '../../redux/url/selectors/UrlSelectors';
import { wishListActions } from '../../redux/wishList/actions/WishListActions.creators';
import MonetateUtil from '../../util/MonetateUtil';
import { getListerItemsToShow } from '../../util/ProductListerUtil';
import { emitter, EmitterEvent } from '../../util/tracking';
import { buildProductClickPayload } from '../../util/TrackingUtil';
export const ListerResultContainer = () => {
    const isClient = useIsClient();
    const { pageInfo, currency } = useAemConfig();
    const isLoading = useSelector(makeGetLoadingState());
    const pageSizeInformation = useSelector(makeGetUrlInformationPageSize());
    const productSearchInformation = useSelector(makeGetProductSearchInformationState());
    const contentBlocks = useSelector(makeGetContentBlocks());
    const singleActiveSizeFilterKeyName = useSelector(makeGetSingleActiveSizeFilterKeyName());
    const compareItems = useSelector(makeGetCompareItems());
    const urlInformationSearch = useSelector(makeGetUrlInformationSearch());
    const itemsToShow = getListerItemsToShow(productSearchInformation.items || [], pageSizeInformation, isClient);
    const dispatch = useDispatch();
    const onTileClick = (_e, product) => {
        dispatch(analyticsActions.createTileClickAction());
        emitter.emit(EmitterEvent.PRODUCT_CLICK, buildProductClickPayload(product.productId, { sourceId: productSearchInformation.sourceId }));
    };
    const onWishListToggle = (wishListProduct) => dispatch(wishListActions.toggleProduct(wishListProduct));
    const updateCompareList = (compareProduct) => dispatch(compareActions.createUpdateOnListerAction(compareProduct));
    useEffect(() => {
        dispatch(listerActions.createInitializeAction());
        dispatch(analyticsActions.productSearchPersonalization({
            personalized: Boolean(productSearchInformation.personalized),
            traits: productSearchInformation.traits || [],
        }));
        if (pageInfo.isCategoryPage || pageInfo.isBrandAsCategoryPage || pageInfo.isBrandPage) {
            dispatch(analyticsActions.listerResults(productSearchInformation.itemCount));
        }
        dispatch(analyticsActions.listerViewProductList(productSearchInformation.items || [], currency, pageInfo.isSearchPage ? Events.VIEW_SEARCH_RESULTS : Events.VIEW_PRODUCT_LIST, urlInformationSearch));
    }, []);
    useEffect(() => {
        if (isClient) {
            MonetateUtil.pushListerEvent(itemsToShow.filter(item => item.productId));
        }
    }, [isClient]);
    return (_jsx(GridTileContainer, { isLoading: isLoading, items: itemsToShow, onTileClick: onTileClick, onWishListToggle: onWishListToggle, updateCompareList: updateCompareList, contentBlocks: contentBlocks, singleActiveSizeFilterKeyName: singleActiveSizeFilterKeyName, compareItems: compareItems }));
};
